<template>

  <div class="product-box">
    <div class="product-description">
      <p></p>
      <p>关键人定位</p>
      <p></p>
    </div>

    <div class="product-info">
      <div class="tipbox">
        <div>
          <span v-html="accountInfo.emailfinder.count"></span>
          /{{ accountInfo.emailfinder.upperLimit }}
        </div>
        <span>剩余可查询数据</span>
        <div class="mask">
          <p>查询次数=</p>
          <p>
            本周剩余次数({{ parseInt(accountInfo.emailfinder.count)-parseInt(accountInfo.emailfinder.present) }})+
            <span>当周未用完，下周将清零</span>
          </p>
          <p>
            升级权益获取次数({{ accountInfo.emailfinder.present }})
            <span>永久有效，用完为止。</span>
          </p>
        </div>
      </div>

      <a-divider type="vertical" />

      <div class="tipbox">
        <div>
          <span v-html="accountInfo.emailfinder.scount"></span>
          /{{ accountInfo.emailfinder.supperLimit }}
        </div>
        <span>剩余可使用搜索次数</span>
        <div class="mask">
          <p>搜索次数=</p>
          <p>
            本周剩余次数({{ parseInt(accountInfo.emailfinder.scount)-parseInt(accountInfo.emailfinder.spresent) }})+
            <span>当周未用完，下周将清零</span>
          </p>
          <p>
            升级权益获取次数({{ accountInfo.emailfinder.spresent }})
            <span>永久有效，用完为止。</span>
          </p>
        </div>
      </div>
    </div>

    <div class="upgrade">
      <a-button size="large" type="primary" @click="upgrade" v-if="accountInfo.interest=='registered'">升级权益</a-button>
    </div>

    <div class="invite">
      <i class="icon-tip"></i>
      <p>
        我已邀请了 <span>{{ (invitionList||[]).length }}</span> 人:
      </p>
      <div v-show="!!invitionList">
        <ul ref="invite">
          <li v-for="(v,i) in invitionList" :key="i">{{ v }}</li>
        </ul>
      </div>
      <div v-show="!invitionList">
        还未成功邀请到哦，动动手分享你的专属链接，提升权益吧^_^
      </div>
      <a-button v-if="accountInfo.interest=='registeredPlus'" class="copy-btn" size="small" :data-clipboard-text="accountInfo.pcInvite">邀请提升权益</a-button>

      <a-tooltip placement="topRight" arrowPointAtCenter overlayClassName="invite-tip">
        <template slot="title">
          <p>
            邀请新用户注册
            <span>
              搜索次+20，可查数据+10(每成功邀请一名新用户注册可叠加获取一次对应权益)
            </span>
          </p>
        </template>
        <a-icon type="question-circle" />
      </a-tooltip>
    </div>

    <a-modal v-model="interest" :footer="null" :width="690" title="权益说明" class="interest">
      <div class="desc-header">
        <ul>
          <li>1.基础注册用户以每周一至周日为一个周期，每个周期内可用关键人定位功能完成20次结果搜索，并可查看10个关键人详情，每周一重置基础权益，不可叠加；</li>
          <li>2.一个周期的基本权益用完之后需要等到下一个周期（即下一周的周一）方可重新获取新一轮权益，或可通过以下操作获取额外的权益且不受周期清空限制：</li>
        </ul>
      </div>
      <div class="desc-content">
        <div>
          <div>
            <p>完善个人信息
              <span>
                周搜索次数+20，可查数+10次
              </span>
            </p>
            <a-button type="primary" @click="$router.push({name:'profile'})" :disabled="accountInfo.interest=='registeredPlus'">去完善</a-button>
          </div>
        </div>
        <div>
          <div>
            <p>邀请新用户注册
              <span>
                搜索次+20，可查数据+10(每成功邀请一名新用户注册可叠加获取一次对应权益)
              </span>
            </p>
            <a-button type="primary" class="copy-btn2" :data-clipboard-text="accountInfo.pcInvite">复制邀请</a-button>
          </div>
          <p>
            我的邀请链接：{{ accountInfo.pcInvite }}
          </p>
        </div>
      </div>
    </a-modal>
  </div>

</template>

<script>
import ClipboardJS from "clipboard";
var clipboard = new ClipboardJS(".copy-btn");
var clipboard2 = new ClipboardJS(".copy-btn2");
import ActiveExhibitor from "./ActiveExhibitor";
export default {
  data() {
    return {
      interest: false,
      invitionList: []
    };
  },
  computed: {
    accountInfo() {
      return this.$store.state.accountInfo;
    }
  },
  beforeCreate() {
    this.$http.post("/invitionList").then(res => {
      if (!res.error) {
        this.invitionList = res.data.list;
      }
    });
  },
  mounted() {
    clipboard.on("success", e => {
      this.$message.success("链接复制成功");
      e.clearSelection();
    });
    clipboard2.on("success", e => {
      this.$message.success("链接复制成功");
      e.clearSelection();
    });

    if (this.$refs.invite.scrollHeight / 19 > 1) {
      setInterval(() => {
        this.$refs.invite.scrollTop =
          this.$refs.invite.scrollTop +
          ((this.$refs.invite.scrollTop + 19 >=
            this.$refs.invite.scrollHeight &&
            -this.$refs.invite.scrollTop) ||
            19);
        console.log(this.$refs.invite.height);
      }, 3000);
    }
  },
  methods: {
    upgrade() {
      this.interest = true;
    },
    ActiveExhi() {
      this.$dialog(ActiveExhibitor);
    },
    openCustomerService() {
      window.CustomerService && (location.href = window.CustomerService);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
.product-box {
  .product-description {
    display: flex;
    flex-flow: row;
    margin: 20px 0;
    align-items: center;
    justify-content: center;
    p:nth-child(1),
    p:nth-child(3) {
      border-top: 1px solid #e9eef2;
      border-bottom: 1px solid #e9eef2;
      height: 5px;
      flex: 1;
      vertical-align: middle;
      margin: 0;
    }
    p:nth-child(1) {
      border-image: linear-gradient(to right, #fff, #e9eef2) 1 1;
    }
    p:nth-child(3) {
      border-image: linear-gradient(to left, #fff, #e9eef2) 1 1;
    }
    p:nth-child(2) {
      font-weight: bold;
      font-size: 24px;
      color: #333;
      vertical-align: middle;
      margin: 0 10px;
      // width: 230px;
      // height: 45px;
    }
  }

  .product-info {
    text-align: center;
    .tipbox {
      width: 250px;
      height: 250px;
      display: inline-block;
      border-radius: 10px;
      background-color: #f7f7f7;
      position: relative;
      & > div:first-child {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background-color: #fff;
        margin: 20px auto;
        font-size: 18px;
        color: #666;
        padding: 10px;
        & > span {
          display: block;
          font-size: 60px;
          color: #c0c0c0;
        }
      }
      & > span {
        display: block;
        margin: 0 15px;
        height: 50px;
        line-height: 60px;
        color: #aeaeae;
        font-size: 16px;
        border-top: 1px solid #e8e8e8;
      }
      .mask {
        display: none;
      }
      &:hover .mask {
        display: block;
        position: absolute;
        top: 0;
        width: 250px;
        height: 250px;
        background: #00000099;
        border-radius: 10px;
        color: #fff;
        text-align: left;

        p {
          font-size: 16px;
          margin: 20px 0 0;
          padding: 0 0 0 30px;
          line-height: 18px;
          span {
            display: block;
            font-size: 13px;
            color: #ffffff7f;
          }
        }
        & > p:first-child {
          font-size: 18px;
          margin: 50px 100px 0 0;
          border-bottom: 1px solid #727272;
          padding: 0 0 10px 30px;
        }
      }
    }
    & /deep/ .ant-divider {
      height: 250px;
      margin: 0 60px;
      display: inline-block;
      top: 0;
      vertical-align: bottom;
      background: linear-gradient(#fff, #e9eef2, #e9eef2, #e9eef2, #fff);
    }
  }
  .upgrade {
    text-align: center;
    height: 170px;
    & /deep/ .ant-btn {
      text-align: center;
      margin-top: 50px;
      width: 180px;
      border-radius: 0;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .invite {
    margin: 10px 20px;
    font-size: 13px;
    border-top: 1px solid;
    border-bottom: 1px solid;
    padding: 20px 0;
    border-image: linear-gradient(to right, #fff, #e9eef2, #fff) 1 1;
    .icon-tip {
      vertical-align: middle;
      display: inline-block;
      width: 30px;
      height: 22px;
      @include intop-icon;
      background-position: -430px -660px;
    }
    p {
      margin: 0;
      display: inline-block;
      vertical-align: middle;
      color: #666;
      span {
        color: red;
      }
    }
    div {
      width: 620px;
      height: 19px;
      overflow: hidden;
      display: inline-block;
      vertical-align: middle;
      font-size: 13px;
      color: #999;
      ul {
        color: #999;
        margin: 0;
        padding: 0;
        width: 640px;
        height: 19px;
        overflow-y: scroll;
        list-style: none;
        li {
          display: inline-block;
          width: 150px;
          text-align: center;
          color: #999;
          &:not(:nth-child(4n)):not(:last-child) {
            border-right: 1px solid #e4e4e4;
          }
        }
      }
    }

    & /deep/ .ant-btn {
      border-radius: 15px;
      height: 26px;
      font-size: 13px;
      color: #fff;
      background-color: #ff9942;
    }

    & /deep/ .anticon {
      color: #dfdfdf;
      margin: 0 10px;
    }
  }
}
</style>

<style lang="scss">
.invite-tip {
  .ant-tooltip-inner {
    background: #dfdfdf;
    p {
      color: #666;
      font-size: 16px;
      margin: 20px 10px;
      span {
        font-size: 13px;
        display: block;
      }
    }
  }
  .ant-tooltip-arrow {
    border-top-color: #dfdfdf;
  }
}
.interest {
  .ant-modal-header {
    padding: 15px 24px;
    background-color: #f3f3f3;
  }
  .ant-modal-body {
    padding: 0;
    .desc-header {
      background-color: #f6fcff;
      padding: 20px 0;
      border-bottom: 1px solid #bae7ff;
      ul {
        list-style: none;
        border-left: 4px solid #008cd6;
        margin: 0 20px 0 0;
        padding-left: 20px;
        li:not(:first-child) {
          margin: 10px 0 0;
        }
      }
    }

    .desc-content {
      padding: 0 20px;
      & > div {
        &:not(:last-child) {
          border-bottom: 1px dashed #eee;
        }
        padding: 20px 0 0;
        & > div {
          display: flex;
          p {
            flex: 1;
            font-size: 16px;
            color: #333;
            display: inline-block;
            span {
              display: block;
              font-size: 13px;
              color: #999;
            }
          }
          & /deep/ .ant-btn {
            border-radius: 50px;
            width: 120px;
          }
        }
        & > p {
          font-size: 12px;
          color: #999;
          padding: 0 0 20px;
        }
      }
    }
  }
}
</style>